import axios from 'axios';
import qs from 'qs';
import { notification } from 'antd';
import { history } from 'helpers';

const client = axios.create({
  baseURL: `${process.env.PUBLIC_HOST_API}`,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
  paramsSerializer: (params) => {
    return qs.stringify(params, { arrayFormat: 'brackets' });
  },
});

const request = (options) => {
  const onSuccess = (response) => {
    return response.data;
  };
  const onError = (error) => {
    const errorMessage = error?.response?.data?.errors?.details || 'Bir sorun oluştu.';
    if (error?.response?.data?.message?.includes('JWT')) {
      notification.error({
        message: 'Oturum Süresi Doldu.',
        description: 'Tekrar giriş yapınız.',
      });
      history.push('/login');
    }
    return Promise.reject(errorMessage);
  };

  return client(options).then(onSuccess).catch(onError);
};

export default request;
